import {
    Component,
    OnInit,
    ViewChild,
    Input,
    OnDestroy,
} from "@angular/core";
import { BaseComponent } from "../../Library/BaseComponent";
import {
    ComplainRegister,
    ComplainAttachment,
    AddPreferenceRequest,
    ComplainSearch,
    InventoryItems,
} from "../../Models/RequestModels";
import { MasterDataService } from "../../Services/MasterDataService";
import { ActivatedRoute, Router } from "@angular/router";
import {
    CallStatuses,
    EntityCodes,
    JobOperationActions,
    ComplainType,
    AuthActionCodes,
    JobSearch_Compact_Mode,
    JobPopoverMode,
    InventoryTransactionTypes,
} from "../../Models/EnumModels";
import { PMSService } from "../../Services/PMSService";
import { GuestLookup } from "../../Models/ResponseModels";
import * as _ from "lodash";
import { ComplainService } from "../../Services/ComplainService";
import { GlitchService } from "../../Services/GlitchService";
import * as moment from "moment";
import {
    GenericMaster,
    CallDescriptionLookup,
    CallCategoryLookup,
    LocationLookup,
    PropertyBasicInfo
} from "../../Models/GlobalEntities";
import { GuestDetail } from "../GuestDetail/GuestDetail";
import { PendingCalls } from "../PendingCalls/PendingCalls";
import * as Collections from "typescript-collections";
import { ManualAssign } from "../ManualAssign/ManualAssign";
import {
    NgbTimeStruct,
    NgbModal,
    NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { RecurrenceUpdate } from "../RecurrenceUpdate/RecurrenceUpdate";
import { NgSelectComponent } from "@ng-select/ng-select";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { ParkEntry } from "../ParkEntry/ParkEntry";
import { AppSettings } from "../../Library/AppSettings";
import { untilDestroyed } from "ngx-take-until-destroy";
import { JobConsole_Compact } from "../JobConsole_Compact/JobConsole_Compact";
import * as alasql from "alasql";

@Component({
    selector: "RegisterCall",
    templateUrl: "./RegisterCall.html",
})
export class RegisterCall extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild("guest") guest: GuestDetail;
    @ViewChild("pendingcalls") pendingcalls: PendingCalls;
    @ViewChild("manualAssign") manualAssign: ManualAssign;
    @ViewChild("recurrenceUpdate") recurrenceUpdate: RecurrenceUpdate;
    @ViewChild("parkentry") parkentry: ParkEntry;

    @ViewChild("confirm") confirm;

    @ViewChild("cmbLocations") cmbLocations: NgSelectComponent;
    @ViewChild("cmbGuests") cmbGuests: NgSelectComponent;
    @ViewChild("cmbCallCategories") cmbCallCategories: NgSelectComponent;
    @ViewChild("cmbCallDescriptions") cmbCallDescriptions: NgSelectComponent;
    @ViewChild("cmbRequestByStaffId") cmbRequestByStaffId: NgSelectComponent;
    @ViewChild("jobConsole_Compact") jobConsole_Compact: JobConsole_Compact;

    ConfirmModalRef: NgbModalRef;

    // DEV-20345: on split-screen the Location-history panel is shown as a
    // centered overlay dialog (CSS) toggled by this flag, instead of an
    // off-screen side column. The panel stays INSIDE this component's view
    // (not an ng-bootstrap template modal), so jobConsole_Compact.Open() binds
    // data exactly as it does on desktop.
    showLocationDialog: boolean = false;

    openLocationHistory(): void {
        this.showLocationDialog = true;
        // the panel/jobConsole_Compact is already in the view; (re)load the
        // history for the current location, mirroring onLocationChange.
        setTimeout(() => {
            this.HandleLocationChange();
            if (this.Model.LocationId) { this.ShowTab(1); }
            else if (this.Model.RequestedByGuestId) { this.ShowTab(2); }
        }, 0);
    }

    closeLocationHistory(): void {
        this.showLocationDialog = false;
    }

    Model: ComplainRegister;
    SaveModel: Array<ComplainRegister> = [];
    lstGuest: Array<GuestLookup> = new Array<GuestLookup>();
    tabID: number = 1;
    lstLocations: Array<LocationLookup> = [];
    lstStaff: Array<GenericMaster> = [];
    lstPriority: Array<GenericMaster> = [];

    lstCallDescriptions: Array<CallDescriptionLookup> = [];
    AllCallDescriptions: Array<CallDescriptionLookup> = [];

    lstProperties: Array<PropertyBasicInfo> = [];

    lstCallCategories: Array<CallCategoryLookup> = [];
    ActiveTabs = new Collections.Dictionary<number, boolean>();

    AssignTo: GenericMaster;

    showPrefIcon: boolean = false;
    showPrefIcon_Preset: boolean = false;

    disabledPriority: boolean = false;

    ConfirmModel: Array<any>;

    @Input() DisplayMode: number = 1;

    ShowQuickJob: boolean = true;
    _JobSearch_Compact_Mode = JobSearch_Compact_Mode;
    _JobPopoverMode = JobPopoverMode;
    inventoryItems = new Array<InventoryItems>();
    isFoundInventoryWithDesc :InventoryItems = null;
    inventorySingularityEnabled: boolean = false;

    IsKMTCategorySelected = false;

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected pmsService: PMSService,
        private complainService: ComplainService,
        private glitchService: GlitchService,
        private modalService: NgbModal
    ) {
        super(translate, toastr, route, router, masterService);

        this.Model = new ComplainRegister();

        this.ActiveTabs.setValue(1, false);
        this.ActiveTabs.setValue(2, false);
        this.ActiveTabs.setValue(3, false);

        this.complainService.SelectedJob = null;
    }

    ngOnDestroy(): void {
        this.glitchService.SelectedGlitch = null;
    }

    SetModelDefaults(): void {
        this.Model.CallDescriptionsId = null;
        this.Model.CategoryId = null;
        this.Model.Remarks = null;
        this.Model.IsClosed = false;
        this.Model.ClosedReasonCode = 0;
        this.Model.ClosedReasonCode_Close = 0;
        this.Model.ClosedReasonCode_Park = 0;
        this.Model.Priority = 1;
        this.Model.IsAutoAssign = true;
        this.Model.CurrentStatus = CallStatuses.Open;
        this.Model.AssignedTo = null;
        this.AssignTo = null;
        this.Model.Attachments = [];
        this.Model.ReopenTime = null;
        if (this.DisplayMode == 2) this.Model.IsGuestCall = false;
        else this.Model.IsGuestCall = true;
        this.Model.Operation = JobOperationActions.Register;
        this.Model.ResetTime = null;
        this.Model.LastActionRemarks = null;
        this.Model.RequestedByStaffId = null;
        this.Model.ReopenTime = null;
        this.Model.ClosedReasonCode_Park = 0;
        this.Model.ClosedReasonCode_Close = 0;
    }

    ngOnInit(): void {
        // DEV-20345: in split-screen / reduced width the quick-register bar
        // starts collapsed to just the lightning toggle; the user expands it
        // on demand. Full-screen (> 1024px) keeps the bar expanded.
        // NB: DisplayMode is always 2 for the embedded console bar, so the
        // split signal must be viewport width, not DisplayMode.
        if (typeof window !== 'undefined' && window.innerWidth <= 1024) {
            this.ShowQuickJob = false;
        }

        this.SetModelDefaults();

        this.lstProperties = this.masterService.GetProperties_Action(
            AuthActionCodes.CallRegistration
        );
        if (
            this.lstProperties.findIndex(
                (a) => a.PropertyId == this.masterService.ActivePropertyID
            ) > 0
        )
            this.Model.PropertyId = this.masterService.ActivePropertyID;
        else {
            if (this.lstProperties.length > 0)
                this.Model.PropertyId = this.lstProperties[0].PropertyId;
        }

        this.cmbLocations.virtualScroll = true;
        this.cmbCallCategories.virtualScroll = true;
        this.cmbCallDescriptions.virtualScroll = true;
        this.cmbGuests.virtualScroll = true;
        this.cmbRequestByStaffId.virtualScroll = true;

        this.SetMasters();
        if(this.masterService.CheckActiveLicence_Module(this.masterService.ActivePropertyID, 'UF_INV') && AppSettings.IsRunningInSingularity){
            this.inventorySingularityEnabled = true;
            this.getInventoryDetails();
        }
    }

     getInventoryDetails(){
        this.inventoryItems =  this.masterService.getInventoryDetails(this.Model.PropertyId);
    }


    SetQuickCallElement(CallDescriptionId: number): void {
        if (CallDescriptionId <= 0) return;

        let idx = -1;
        let row: CallDescriptionLookup;

        idx = this.lstCallDescriptions.findIndex(
            (a) => a.Id == CallDescriptionId
        );
        if (idx >= 0) {
            row = this.lstCallDescriptions.splice(idx, 1)[0];
            row.IsQuickCall = true;
            this.lstCallDescriptions.unshift(row);
        }
    }

    SetQuickCall(): void {
        this.cmbCallDescriptions.groupBy = null;

        if (this.masterService.LoggedInUserData.QuickCall != null) {
            let idxQC = this.masterService.LoggedInUserData.QuickCall.findIndex(
                (a) => a.PropertyId == this.Model.PropertyId
            );
            if (idxQC >= 0) {
                let qc = this.masterService.LoggedInUserData.QuickCall[idxQC];
                this.SetQuickCallElement(qc.POSITION6);
                this.SetQuickCallElement(qc.POSITION5);
                this.SetQuickCallElement(qc.POSITION4);
                this.SetQuickCallElement(qc.POSITION3);
                this.SetQuickCallElement(qc.POSITION2);
                this.SetQuickCallElement(qc.POSITION1);
                this.cmbCallDescriptions.groupBy = "IsQuickCall";
            }
        }
    }

    SetMasters(): void {
        this.lstLocations = this.masterService.GetLocations(this.Model.PropertyId) ? _.cloneDeep(
            this.masterService.GetLocations(this.Model.PropertyId)
        ) : []; // JSON.parse(JSON.stringify(this.masterService.Cache_PropertyMainMasters.getValue(this.Model.PropertyId).Location));
        this.lstCallDescriptions = this.masterService.GetCallDescritpion(this.Model.PropertyId) ? _.cloneDeep(
            this.masterService.GetCallDescritpion(this.Model.PropertyId)
        ) : [];
        this.lstCallDescriptions = this.lstCallDescriptions.filter(
            (a) => !a.IsDel
        );
        this.lstCallDescriptions.forEach((a) => {
            a.IsQuickCall = false;
            let checkValue = this.checkKMTCategory(this.Model.PropertyId, a.CategoryId);
            if (checkValue) {
                a.IsFromKMTCategory = true;
            }else if(checkValue == false) {
                a.IsFromKMTCategory = false;
            }
        });
        if (
            this.CheckAuth_Dept_Action(
                this.Model.PropertyId,
                0,
                this._AuthActionCodes.QuickCall
            )
        ) {
            this.SetQuickCall();
        }

        this.lstCallCategories = _.cloneDeep(
            this.masterService.GetCallCategories(this.Model.PropertyId)
        );
        this.lstCallCategories = alasql(
            "Select * From ? c Where c.Id In (Select Distinct d.CategoryId From ? d)",
            [this.lstCallCategories, this.lstCallDescriptions]
        );

        this.lstStaff = _.cloneDeep(
            this.masterService.GetStaff(this.Model.PropertyId)
        );

        this.AllCallDescriptions = this.masterService.GetCallDescritpion(this.Model.PropertyId) ? _.cloneDeep(
            this.masterService.GetCallDescritpion(this.Model.PropertyId)
        ) : [];
        this.AllCallDescriptions = this.AllCallDescriptions.filter(
            (a) => !a.IsDel
        );

        this.lstGuest = this.pmsService
            .GetGuestLookup(this.Model.PropertyId)
            .filter((x) => x.ReservationStatus == 2);

        this.SetPriorities();

        this.SetLocationData();

        this.pmsService.GuestLookupChanged.pipe(untilDestroyed(this)).subscribe(
            (PropertyId) => {
                //console.info(this.pmsService.GetGuestLookup(PropertyId));
                if (this.Model.PropertyId == PropertyId) {
                    this.lstGuest = JSON.parse(
                        JSON.stringify(
                            this.pmsService
                                .GetGuestLookup(PropertyId)
                                .filter((x) => x.ReservationStatus == 2)
                        )
                    );
                    this.SetLocationData();
                }
            }
        );
    }

    onPropertyChange(): void {
        let propID = this.Model.PropertyId;
        this.Model = new ComplainRegister();
        this.Model.PropertyId = propID;
        //this.SetModelDefaults();
        //this.pmsService.GuestLookup_Get(this.Model.PropertyId);
        //console.info(this.Model);
        //this.SetMasters();
        this.onClear();
    }

    FindByGuestId(GuestId: number): GuestLookup {
        if (this.lstGuest == null || this.lstGuest.length == 0) return null;

        return this.lstGuest.find((a) => a.GuestId == GuestId);
    }

    FindGuestByLocation(LocationId: number): GuestLookup {
        if (this.lstGuest == null) return null;

        for (let i = 0; i < this.lstGuest.length; i++) {
            if (this.lstGuest[i].LocationId == LocationId)
                return this.lstGuest[i];
        }

        return null;
    }

    SetLocationData(): void {
        for (let i = 0; i < this.lstLocations.length; i++) {
            let row: any = _.cloneDeep(this.lstLocations[i]);
            if (row.OriginalName == null) {
                row.OriginalName = row.Description;
            }

            row.GuestId = null;

            let lookup = this.FindGuestByLocation(row.Id);
            if (lookup != null) {
                row.Description = _.assign(lookup.FullName);
                row.GuestId = lookup.GuestId;
                row.TritonReservationId = lookup.TritonReservationId;
            } else {
                if (row.OriginalName != null)
                    row.Description = row.OriginalName;
            }

            this.lstLocations.splice(i, 1, row);

            this.lstLocations = [...this.lstLocations];

            //window.setTimeout(() => this.lstLocations.splice(i, 1, row), 0);
        }
    }

    SetPriorities(): void {
        let callDesc = null;
        let forPrior = 1;

        if (this.Model.CallDescriptionsId != null) {
            callDesc = this.masterService.FindCallDescription(
                this.Model.PropertyId,
                this.Model.CallDescriptionsId
            );
        }

        if (callDesc != null) {
            forPrior = callDesc.Priority;
        }

        this.lstPriority = this.masterService.Cache_Global.Priority.filter(
            (a) => {
                if (forPrior != 4) {
                    return a.Id != 4;
                } else {
                    return true;
                }
            }
        );

        this.Model.Priority = forPrior;
    }

    DescriptionChanged(data: CallDescriptionLookup): void {
        this.isFoundInventoryWithDesc = null;
         if(this.inventorySingularityEnabled && data.Id){
            const found = this.inventoryItems.find(elem => elem.CallDescriptionId === data.Id);
            this.isFoundInventoryWithDesc = found ? { ...found } : null;
        } 
        this.HighlightPrefIcon();
        this.disabledPriority = false;
        if (data == null) {
            return;
        }

        this.Model.CategoryId = data.CategoryId;
        this.Model.CurrentStatus = "OPN";

        this.SetPriorities();

        this.disabledPriority = this.Model.Priority == 4 ? true : false;

        if (data.ComplainType == ComplainType.ServiceRequest) {
            this.guest.ChangeNav(2);
        } else {
            this.guest.ChangeNav(1);
        }

        this.HighlightPrefIcon();

        // check for kmt description
        this.IsKMTCategorySelected = this.checkKMTCategory(
            this.Model.PropertyId,
            this.Model.CategoryId
        );
    }

    HighlightPrefIcon() {
        this.showPrefIcon = false;
        this.showPrefIcon_Preset = false;

        if (
            this.Model.RequestedByGuestId == null ||
            this.Model.CallDescriptionsId == null
        ) {
            return;
        }

        let objCall = this.masterService.FindCallDescription(
            this.Model.PropertyId,
            this.Model.CallDescriptionsId
        );

        if (objCall == null) return;

        if (objCall.ComplainType == ComplainType.ServiceRequest) {
            this.showPrefIcon = true;

            if (
                this.guest &&
                this.guest.Model &&
                this.guest.Model.GuestPreferences &&
                this.guest.Model.GuestPreferences.length > 0
            ) {
                let idx = this.guest.Model.GuestPreferences.findIndex(
                    (x) =>
                        x.CallDescriptionId == this.Model.CallDescriptionsId &&
                        x.GuestId == this.Model.RequestedByGuestId
                );
                this.showPrefIcon_Preset = idx >= 0;
            }
        }
    }

    ShowTab(tabID: number): void {
        this.ActiveTabs.setValue(tabID, true);
        this.tabID = tabID;
    }

    HideTab(tabID: number): void {
        this.ActiveTabs.setValue(tabID, false);
        this.tabID = null;

        this.ActiveTabs.forEach((key, value) => {
            if (value == true) {
                this.tabID = key;
                return;
            }
        });
    }

    checkKMTCategory(propertyId: number, categoryId: number): boolean {
        const callCategory = this.masterService.FindCallCategory(
            propertyId,
            categoryId
        );
        return callCategory ? callCategory.IsKMTCategory : false;
    }

    onCategoryChange(): void {
        this.IsKMTCategorySelected = this.checkKMTCategory(
            this.Model.PropertyId,
            this.Model.CategoryId
        );

        let arr = new Array<CallDescriptionLookup>();
        this.AllCallDescriptions.map((row, idx) => {
            if (this.Model.CategoryId == null) {
                arr.push(row);
            } else {
                if (row.CategoryId == this.Model.CategoryId) {
                    if (this.IsKMTCategorySelected) {
                        row.IsFromKMTCategory = true;
                    }
                    arr.push(row);
                }
            }
        });

        this.lstCallDescriptions = arr;
        this.lstCallDescriptions.forEach((a) => {
            a.IsQuickCall = false;
            let checkValue = this.checkKMTCategory(this.Model.PropertyId, a.CategoryId);
            if (checkValue) {
                a.IsFromKMTCategory = true;
            }else if(checkValue == false) {
                a.IsFromKMTCategory = false;
            }

        });
        if (
            this.CheckAuth_Dept_Action(
                this.Model.PropertyId,
                0,
                this._AuthActionCodes.QuickCall
            )
        ) {
            this.SetQuickCall();
        }

        this.Model.CallDescriptionsId = null;
        this.showPrefIcon = false;
    }

    HandleLocationChange(): void {
        this.complainService.SelectedJob = null;
        if (!this.jobConsole_Compact) {
            return;
        }
        if (this.Model.LocationId == null) {
            this.jobConsole_Compact.Open(null);
            return;
        }

        let req = new ComplainSearch();
        req.Locations = [this.Model.LocationId];
        req.Properties = [this.Model.PropertyId];
        req.PageNumber = 1;
        req.PageSize = 15;
        req.OrderBy = "REPORTEDAT";

        this.jobConsole_Compact.Open(req);
    }

    onLocationChange(data: any): void {
        this.HandleLocationChange();

        if (data == null) {
            this.HideTab(1);

            if (!this.Model.IsGuestCall) {
                this.HideTab(2);
                this.Model.RequestedByGuestId = null;
            }
            return;
        }

        //console.info(data);

        this.ShowTab(1);

        if (
            data.GuestId == undefined ||
            data.GuestId == null ||
            this.Model.RequestedByGuestId != null
        ) {
            this.Model.IsGuestCall = false;
            this.Model.RequestedByGuestId = null;
            this.Model.TritonReservationId = null;
            this.guest.GuestParams(null, null);
            return;
        } else {
            this.Model.IsGuestCall = true;

            let dataGuest = this.FindByGuestId(data.GuestId);
            if (dataGuest != null) {
                this.Model.TritonReservationId = dataGuest.TritonReservationId;

                this.Model.RequestedByGuestId = dataGuest.GuestId;
                if (
                    this.CheckAuth_Dept_Action(
                        this.Model.PropertyId,
                        0,
                        this._AuthActionCodes.FrontOffice
                    )
                ) {
                    this.guest.GuestParams(
                        dataGuest.GuestId,
                        dataGuest.TritonReservationId
                    );
                    this.ShowTab(2);
                }
            }

            this.SetLocationData();
        }
    }

    onGuestChange(data: GuestLookup): void {
        this.HighlightPrefIcon();

        if (data == null) {
            this.HideTab(2);
            return;
        }
        if (
            this.CheckAuth_Dept_Action(
                this.Model.PropertyId,
                0,
                this._AuthActionCodes.FrontOffice
            )
        ) {
            this.guest.GuestParams(data.GuestId, data.TritonReservationId);
            this.ShowTab(2);
        }
        if (data.GuestId == undefined || data.GuestId == null) return;

        this.Model.TritonReservationId = data.TritonReservationId;

        if (this.Model.LocationId != null) return;

        this.Model.LocationId = data.LocationId;

        this.ShowTab(1);

        this.HandleLocationChange();
    }

    Validate(): void {
        let cDate = new Date();

        if (this.Model.LocationId == null) {
            this.AddError("ERR.ERR_SELECT_LOCATION");
        }

        if (this.Model.CallDescriptionsId == null) {
            this.AddError("ERR.ERR_SELECT_DESCR");
        }

        if (
            this.Model.CurrentStatus == CallStatuses.Close &&
            (this.Model.ClosedReasonCode == null ||
                this.Model.ClosedReasonCode <= 0)
        ) {
            this.AddError("ERR.ERR_SELECT_CLOSING_REASON");
        }

        if (this.isFoundInventoryWithDesc && this.inventorySingularityEnabled && (this.isFoundInventoryWithDesc.DefaultQuantity == null || this.isFoundInventoryWithDesc.DefaultQuantity == 0) ) {
            this.AddError("ERR.ERR_QUANTITY_NOT_LESS_THAN_1");
        }

        if (this.Model.IsGuestCall && this.Model.RequestedByGuestId == null) {
            this.AddError("ERR.ERR_SELECT_GUEST_FOR_GUEST_CALL");
        }

        if (this.Model.IsAutoAssign == false && this.Model.AssignedTo == null) {
            this.AddError("ERR.ERR_SELECT_STAFF_FOR_MANUAL_ASSIGNMENT");
        }

        if (this.Model.CurrentStatus == CallStatuses.Park) {
            if (
                this.Model.ClosedReasonCode == null ||
                this.Model.ClosedReasonCode <= 0
            ) {
                this.AddError("ERR.ERR_SELECT_PARKING_REASON");
            }

            if (this.Model.ReopenTime == null) {
                this.AddError("ERR.ERR_REQ_REOPEN_TIME_FOR_PARKED_CALL");
            } else {
                if (this.Model.ReopenTime <= cDate) {
                    this.AddError(
                        "ERR.ERR_REOPEN_DATE_GEATER_THAN_CURRENT_DATE"
                    );
                }
            }
        }

        if (this.SaveModel.length > 0) {
            //const desc = this.masterService.FindCallDescription(this.Model.PropertyId, this.Model.CallDescriptionsId)

            let idxDup = this.SaveModel.findIndex(
                (a) =>
                    a.LocationId == this.Model.LocationId &&
                    //&& desc
                    //&& !desc.IsduplicateAllowed
                    a.CallDescriptionsId == this.Model.CallDescriptionsId
            );
            if (idxDup >= 0) {
                this.AddError("ERR.ERR_DUPLICATE_CALL");
            }
        }
    }

    ValidateAttachmentSize(): void {
        let size_Attach = 0;

        for (let i = 0; i < this.SaveModel.length; i++) {
            let row = this.SaveModel[i];
            if (row.Attachments != null && row.Attachments.length > 0) {
                row.Attachments.forEach((rowAttach) => {
                    if (rowAttach != null && rowAttach.Base64String != null)
                        size_Attach += rowAttach.Base64String.length;
                });
            }
        }

        if (
            this.Model.Attachments != null &&
            this.Model.Attachments.length > 0
        ) {
            this.Model.Attachments.forEach((rowAttach) => {
                if (rowAttach != null && rowAttach.Base64String != null)
                    size_Attach += rowAttach.Base64String.length;
            });
        }

        if (size_Attach > AppSettings.MAX_UPLOAD_SIZE) {
            let errorText = this.translate.instant("ERR.ERR_ATTACHMENT_SIZE");
            this.AddError(
                errorText + " " + AppSettings.MaxUploadSize_MB() + " MB"
            );
        }
    }

    Transform(): void {
        if (this.Model.CurrentStatus == CallStatuses.Park) {
            this.Model.ClosedReasonCode = this.Model.ClosedReasonCode_Park;
        }

        if (this.Model.CurrentStatus == CallStatuses.Close) {
            this.Model.ClosedReasonCode = this.Model.ClosedReasonCode_Close;
        }
    }

    FormSubmit(): void {
        if (this.IsSubmitting) return;

        this.SubmitStart();

        //console.info(this.Model);

        this.ClearErrors();

        let arr: Array<ComplainRegister> = [];

        if (this.SaveModel.length > 0) {
            arr = _.cloneDeep(this.SaveModel);
        }

        if (this.SaveModel.length == 0) {
            this.Transform();

            this.Validate();

            if (this.HasErrors) {
                if (this.DisplayMode == 2) {
                    this.ShowErrorInPopup();
                }

                this.SubmitEnd();
                return;
            }

            if (this.Model.IsGuestCall == false)
                this.Model.RequestedByGuestId = null;
                if(this.inventorySingularityEnabled && this.isFoundInventoryWithDesc){
                    this.Model['InventoryJobMappings'] = [this.isFoundInventoryWithDesc];
                    this.Model.InventoryJobMappings[0]['ComplainId'] = 0;
                    this.Model.InventoryJobMappings[0]['StockLocationId'] = 0;
                    this.Model.InventoryJobMappings[0]['InventoryTransactionType'] = InventoryTransactionTypes.Reserve;
                }
            arr.push(this.Model);
        }

        console.info(arr);

        this.complainService.RegisterCall(arr).then((data) => {
            this.SubmitEnd();
            this.FromBaseResponse(data);
            if (this.HasErrors) {
                if (this.DisplayMode == 2) {
                    this.ShowErrorInPopup();
                }
                return;
            }

            this.ConfirmModel = data.Result;
            this.isFoundInventoryWithDesc = null;
            this.IsKMTCategorySelected = false;
            this.onClear();

            this.ConfirmModalRef = this.modalService.open(this.confirm, {
                size: "lg",
            });
        });
    }

    AddMultiple(): void {
        if (
            this.SaveModel != null &&
            this.SaveModel.length >= AppSettings.MAX_CALLS
        ) {
            let strMax = this.GetTranslation("ERR.ERR_MAX_CALLS");
            strMax = strMax.replace(
                "#maxcalls#",
                AppSettings.MAX_CALLS.toString()
            );
            alert(strMax);
            return;
        }

        this.ClearErrors();

        this.Transform();

        this.Validate();

        this.ValidateAttachmentSize();

        if (this.HasErrors) {
            return;
        }

        let row: any = this.Model;

        row.CallDescriptions = this.masterService.MasterData_GetMutli(
            row.PropertyId,
            row.CallDescriptionsId,
            EntityCodes.CallDescriptions,
            ""
        );
        row.PriorityText = this.masterService.StaticData_GetMutli(
            row.Priority,
            EntityCodes.Priority,
            row.Priority
        );
        row.LocationName = this.masterService.MasterData_GetMutli(
            row.PropertyId,
            row.LocationId,
            EntityCodes.Location,
            ""
        );

        this.SaveModel.push(_.cloneDeep(this.Model));

        let gCall = this.Model.IsGuestCall;

        this.SetModelDefaults();

        this.Model.IsGuestCall = gCall;

        if (this.manualAssign != null) this.manualAssign.onClear();

        this.SetMasters();

        this.ShowTab(3);

        this.HighlightPrefIcon();
    }

    onAutoAssign(): void {
        if (this.Model.IsAutoAssign == false) {
            let res = this.manualAssign.OpenForAssignment(
                this.Model.CallDescriptionsId,
                this.Model.LocationId,
                this.Model.PropertyId,
                null
            );
            if (res == false) {
                setTimeout(() => (this.Model.IsAutoAssign = true), 0);
            }
        } else {
            this.AssignTo = null;
            this.Model.AssignedTo = null;
            this.Model.AssignedToName = null;
        }
    }

    onAssignedToChanged(StaffId: number): void {
        if (
            StaffId == null &&
            this.Model.IsAutoAssign == false &&
            this.Model.AssignedTo != null
        )
            return;

        this.Model.AssignedTo = StaffId;

        if (this.Model.AssignedTo != null) {
            this.AssignTo = this.masterService.FindStaff(
                this.Model.PropertyId,
                StaffId
            );
            this.Model.IsAutoAssign = false;
            if (this.AssignTo != null)
                this.Model.AssignedToName = this.AssignTo.Name;
        } else {
            this.AssignTo = null;
            this.Model.IsAutoAssign = true;
            this.Model.AssignedToName = null;
        }
    }

    onAttachmentChanged(data: Array<ComplainAttachment>): void {
        this.Model.Attachments = data;
    }

    onRecurrence(): void {
        this.ClearErrors();
        this.Transform();
        this.Validate();
        if (this.HasErrors) return;

        if (this.guest.TritonReservationId)
            this.Model.TritonReservationId = this.guest.TritonReservationId;

        this.recurrenceUpdate.Open(this.Model);
    }

    onClear(): void {
        this.SaveModel = [];
        let propID = this.Model.PropertyId;
        this.Model = new ComplainRegister();
        this.Model.PropertyId = propID;
        this.SetModelDefaults();
        this.IsKMTCategorySelected = false;
        //console.info(this.Model);
        this.SetMasters();
        this.ClearErrors();

        if (this.manualAssign != null) this.manualAssign.onClear();

        if (this.parkentry != null) this.parkentry.onClear();

        this.jobConsole_Compact.Open(null);
        this.complainService.SelectedJob = null;

        this.guest.GuestParams(null, null);
        this.complainService.SelectedJob = null;
    }

    onCallDelete(idx: number): void {
        this.SaveModel.splice(idx, 1);
        if (this.SaveModel.length == 0) {
            this.tabID = 1;
        }
    }

    onGuestLoaded(row: any): void {
        this.HighlightPrefIcon();
    }

    onPreferenceLoaded(row: any): void {
        this.Model.PropertyId = row.PropertyId;
        this.Model.TritonReservationId = row.TritonReservationId;
        this.Model.LocationId = row.LocationId;
        this.Model.RequestedByGuestId = row.GuestId;
        this.Model.CategoryId = row.CallCategoryId;
        this.onCategoryChange();
        this.Model.CallDescriptionsId = row.CallDescriptionId;

        let ob = new CallDescriptionLookup();
        ob.CategoryId = this.Model.CategoryId;
        ob.ComplainType = ComplainType.ServiceRequest;
        ob.Description = row.CallDescription;
        ob.Id = this.Model.PropertyId;
        ob.Priority = this.Model.Priority;

        this.DescriptionChanged(ob);
    }

    AddPreference(): void {
        let req = new AddPreferenceRequest();
        req.GuestId = this.Model.RequestedByGuestId;
        req.CallDescriptionId = this.Model.CallDescriptionsId;
        req.SystemId = "Unifocus";
        const FOAllowed = this.CheckAuth_Dept_Action(
            this.Model.PropertyId,
            0,
            this._AuthActionCodes.FrontOffice
        );

        if (FOAllowed) {
            this.ShowTab(2);
            this.guest.ChangeNav(2);
        }

        this.pmsService.Guest_AddPreference(req).then((data) => {
            if (FOAllowed) {
                this.guest.Model.GuestPreferences = data.GuestPreferences;
            }
            this.HighlightPrefIcon();
        });
    }

    GetDeptId(): number {
        if (this.Model == null || this.Model.CallDescriptionsId == null)
            return null;

        let deptId = this.masterService.GetCallDescription_Dept(
            this.Model.PropertyId,
            this.Model.CallDescriptionsId
        );
        return deptId;
    }

    StaffRequest() {
        this.Model.RequestedByGuestId = null;
        this.Model.TritonReservationId = null;
        //this.ShowTab(1);
        this.HideTab(2);
    }

    //RefreshGuest() {
    //    this.pmsService.GuestLookup_Get(this.Model.PropertyId, false).then(data => {
    //        if (data && data.length > 0) {
    //            this.lstGuest = data.filter(x => x.ReservationStatus == 2);
    //        }

    //    });
    //}

}
